<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'CustomerList',
})
</script>
<template>
    <a-card :bordered="false">
        <div class="table-page-search-wrapper">
            <a-form>
                <a-row :gutter="48"><a-col :md="6" :sm="24">
                        <a-form-item label="主体类型" name="main_type">
                            <a-select allow-clear mode="multiple" v-model:value="queryParam.main_type"
                                placeholder="请选择">
                                <a-select-option :value="1">公司</a-select-option>
                                <a-select-option :value="2">个体户</a-select-option>
                                <a-select-option :value="3">个独</a-select-option>
                                <a-select-option :value="4">合伙</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <a-form-item label="主体名称" name="nameOrCode">
                            <a-input @keyup.enter="loadData" v-model:value="queryParam.nameOrCode"
                                placeholder="请输入主体名称、税号" @click="
                                    () => {
                                        if (data.tabsKey == 1 || data.tabsKey == 3) {
                                            data.tabsKey = data.tabsKey + 1
                                        }
                                    }
                                ">
                            </a-input>
                        </a-form-item>
                    </a-col>

                    <a-col :md="6" :sm="24">
                        <a-form-item label="注销类型" name="logout_type">
                            <a-select allow-clear mode="multiple" v-model:value="queryParam.logout_type"
                                placeholder="请选择">
                                <a-select-option :value="1">简易注销</a-select-option>
                                <a-select-option :value="2">一般注销</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <a-form-item label="注销状态" name="status">
                            <a-select allow-clear mode="multiple" v-model:value="queryParam.status" placeholder="请选择"
                                @change="changestatus" :disabled="data.queryParamstatus">
                                <a-select-option :value="1">已录单</a-select-option>
                                <a-select-option :value="2">资料完成</a-select-option>
                                <a-select-option :value="3">营业执照作废/注销公示中</a-select-option>
                                <a-select-option :value="4">公示到期</a-select-option>
                                <a-select-option :value="5">待签名</a-select-option>
                                <a-select-option :value="6">等待审核结果</a-select-option>
                                <a-select-option :value="7">退回待修改</a-select-option>
                                <a-select-option :value="8">执照已失效</a-select-option>
                                <a-select-option :value="9">已办结</a-select-option>
                                <a-select-option :value="10">注销失败</a-select-option>
                                <a-select-option :value="13">营业执照作废/公示失败</a-select-option>
                                <a-select-option :value="15">推送异常</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <a-form-item label="录入系统时间" name="between_time">
                            <a-range-picker :show-time="{ defaultValue: arrayMonent }" :value="rangTime"
                                @change="rangTimeChange" :format="format"></a-range-picker>
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <a-form-item label="最后查询时间" name="check_time">
                            <a-range-picker :show-time="{ defaultValue: arrayMonent }" :value="checkTime"
                                @change="checkTimeChange" :format="format"></a-range-picker>
                        </a-form-item> </a-col><a-col :md="6" :sm="24">
                        <a-form-item label="来源号码" name="lianxi_mobile">
                            <a-input @keyup.enter="loadData" v-model:value="queryParam.lianxi_mobile" placeholder="请输入">
                            </a-input>
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <a-form-item label="代理姓名" name="sellerName">
                            <a-input @keyup.enter="loadData" v-model:value="queryParam.sellerName" placeholder="请输入">
                            </a-input>
                        </a-form-item>
                    </a-col>

                    <a-col :md="6" :sm="24">
                        <div class="navlist">
                            <a-button type="primary" :icon="h(PlusOutlined)" @click="handleAdd">新建注销主体</a-button>
                            <a-button type="primary">查询税务登记情况</a-button>
                        </div>
                    </a-col><a-col :md="6" :sm="24">
                        <a-form-item label="查询所有客户" name="recycle">
                            <a-switch :checkedValue="1" :unCheckedValue="2" checked-children="是" un-checked-children="否"
                                v-model:checked="queryParam.recycle" @change="recycleChange"></a-switch>
                        </a-form-item> </a-col><a-col :md="6" :sm="24">
                        <a-form-item label="注销备注" name="lianxi_name">
                            <a-input @keyup.enter="loadData" v-model:value="queryParam.lianxi_name" placeholder="请输入">
                            </a-input>
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <div class="table-page-search-submitButtons" style="overflow: hidden; margin-bottom: 0">
                            <a-button type="primary" @click="loadData">查询</a-button>
                            <a-button type="primary" @click="onActionClick({}, 'SignatureStatus')" v-if="user.id == 1"
                                class="ml-1x">查询客户签字状态</a-button>
                        </div>
                    </a-col>
                </a-row>
            </a-form>
        </div>
        <div class="tabs">
            <a-tabs v-model:activeKey="data.tabsKey" @change="tabsChange">
                <a-tab-pane :key="'db'">
                    <template #tab>
                        <a-badge :count="data.navig.navig_db" :offset="[5, -5]">
                            <span> 所有代办 </span>
                        </a-badge>
                    </template>
                </a-tab-pane>
                <a-tab-pane :key="1">
                    <template #tab>
                        <a-badge :count="data.navig.navig_1" :offset="[5, -5]">
                            <span> 已录单 </span>
                        </a-badge>
                    </template>
                </a-tab-pane>
                <a-tab-pane :key="2">
                    <template #tab>
                        <a-badge :count="data.navig.navig_2" :offset="[5, -5]">
                            <span> 资料准备完毕 </span>
                        </a-badge>
                    </template>
                </a-tab-pane>
                <a-tab-pane :key="5">
                    <template #tab>
                        <a-badge :count="data.navig.navig_5" :offset="[5, -5]">
                            <span> 待签名 </span>
                        </a-badge>
                    </template>
                </a-tab-pane>
                <a-tab-pane :key="6">
                    <template #tab>
                        <a-badge :count="data.navig.navig_6" :offset="[5, -5]">
                            <span> 等待审核结果 </span>
                        </a-badge>
                    </template>
                </a-tab-pane>
                <a-tab-pane :key="7">
                    <template #tab>
                        <a-badge :count="data.navig.navig_7" :offset="[5, -5]">
                            <span> 退回待修改 </span>
                        </a-badge>
                    </template>
                </a-tab-pane>
                <a-tab-pane :key="3">
                    <template #tab>
                        <a-badge :count="data.navig.navig_3" :offset="[5, -5]">
                            <span> 注销公示中 </span>
                        </a-badge>
                    </template>
                </a-tab-pane>
                <a-tab-pane :key="4">
                    <template #tab>
                        <a-badge :count="data.navig.navig_4" :offset="[5, -5]">
                            <span> 公示已到期 </span>
                        </a-badge>
                    </template>
                </a-tab-pane>
                <a-tab-pane :key="56">
                    <template #tab>
                        <a-badge :count="data.navig.navig_56" :offset="[5, -5]">
                            <span> 今日待查询主体 </span>
                        </a-badge>
                    </template>
                </a-tab-pane>
            </a-tabs>
            <div class="tabs-right"></div>
        </div>
        <a-table rowClassName="tableRowClass" :columns="columns" size="small" :loading="data.loading"
            :data-source="dataSource" :pagination="pagination" @change="onChange">
            <template #bodyCell="{ column, record, index, text }">
                <template v-if="column.dataIndex === 'full_name'">
                    <div class="companyInformation">
                        <div class="mv-1x">
                            <a-popover trigger="click" v-model:open="record.isShowCompany"
                                overlayClassName="customer-options-popover">
                                <template #content>
                                    <p @click="handleDoubleNameClick(record.full_name, 1)">跳转到天眼查</p>
                                    <p @click="handleDoubleNameClick(record.full_name, 2)">跳转到企查查</p>
                                </template>
                                <div class="mr-1x pointer"></div>
                            </a-popover>
                            <span class="mr-1x pointer" @click="
                                (e) => {
                                    record.isShowCompany = false
                                    handleNameClick(e, record.full_name)
                                }
                            " @dblclick="
                    () => {
                        record.isShowCompany = true
                    }
                " v-html="record.fullName"></span>
                            <a-tag class="pointer" v-if="record.pay_status == 2" color="#f50"
                                @click="onDirectPaymentClick(record)">未支付</a-tag>
                            <a-tag color="cyan" v-else-if="record.pay_status == 1">已支付√</a-tag>
                            <a-tag color="gray" v-else-if="record.pay_status == 3">已退款</a-tag>
                        </div>
                        <div class="mb-x pointer">
                            <span @dblclick="onTaxInquiryClick(record, 3)" @click="
                                (e) => {
                                    handleNameClick(e, record.social_credit_code)
                                }
                            ">{{ record.social_credit_code }}</span>
                        </div>
                        <div class="mb-x" v-if="record.logout_sqtype == 1">{{ record.liaison_identity ?
                            record.liaison_identity : '未填写' }}
                        </div>
                        <div class="mb-x">
                            <a-tag color="green" v-if="record.main_type != 2 && record.logout_type == 1">简易注销</a-tag>
                            <a-tag color="pink" v-if="record.main_type != 2 && record.logout_type == 2">一般注销</a-tag>
                            <a-tag color="blue">{{ record.logout_sqtype == 1 ? '收验证码' : '电子执照授权' }}</a-tag>
                            <a-tag color="blue" v-if="record.areaName"> {{ record.areaName }}</a-tag>
                        </div>
                        <div class="mb-x" v-if="record.lianxi_name" style="border: 1px dashed #ccc; padding: 5px">备注：{{
                            record.lianxi_name
                            }}</div>
                    </div>
                </template>
                <template v-else-if="column.dataIndex === 'status'">
                    <div class="statusbox">
                        <div class="statuslist">
                            【{{ record.order_status?.after_status_name }}<span v-if="record.deleted_at"
                                style="color: red">-已删除</span>】<span class="mb-x"
                                v-if="record.status == 5 && user.id == 1"><a
                                    @click="onActionClick(record, 'SignatureStatus')">查询签字状态</a></span>
                        </div>
                        <p class="mb-x">状态改变时间：{{ record.order_status?.created_at }}</p>
                        <p v-if="record.last_check_time">最后查询时间：{{ record.last_check_time }}</p>
                        <div style="height: 24px">
                            <a @click="onViewLogClick(record, 1)">查看更多</a>
                            <div class="deng" style="float: right">
                                <a-popconfirm title="确定推送?" @confirm="handleTuiSYBJ(record)">
                                    <a v-if="record.status != 9 && record.status != 10">推送为已办结</a>
                                </a-popconfirm>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else-if="column.dataIndex === 'appFlog_sumType'" style="border: 3px dashed #ccc">
                    <!-- 第一步：处理营业执照（公司+个体通用） -->
                    <div class="mb-x">
                        <a-steps direction="vertical" size="small" v-if="record.main_type == 2" :percent="60">
                            <a-step :disabled="true"
                                :title="'第一步 ' + (processStatus.gt_step1[record.status] ? '未完成 ×' : '已完成 √')"
                                :status="processStatus.gt_step1[record.status] ?? 'finish'">
                                <template #description>
                                    <a-image v-for="(item, idx) in record.business_license_and_copy" :key="idx"
                                        :width="20" :src="$store.state.user.image_domain + item" class="giveborder" />
                                    <a-button type="primary" class="ml-1x" :loading="record.zfgsloading" size="small"
                                        v-if="[1, 2, 13].includes(record.status)"
                                        @click="handleZFGS(record)">操作第一步</a-button>
                                </template>
                            </a-step>
                            <a-step :disabled="true"
                                :title="'第二步 ' + (processStatus.gt_step2[record.status] ? '' : '已完成 √')"
                                :status="processStatus.gt_step2[record.status] ?? 'finish'"
                                v-if="![1, 2, 13].includes(record.status)">
                                <template #description>
                                    <a-image :width="20" v-if="record.cancel_proof"
                                        :src="$store.state.user.image_domain + record.cancel_proof"
                                        class="giveborder" />
                                    <a-button type="primary" :loading="record.zxloading" @click="zhuxiao(record)"
                                        class="ml-1x" size="small"
                                        v-if="record.status == 3 || record.status == 15">操作第二步</a-button>
                                </template>
                            </a-step>
                            <a-step :title="processStatus.step3[record.status] == 'process'
                                    ? '等待审核结果'
                                    : processStatus.step3[record.status] == 'wait'
                                        ? '第三步 进行中......'
                                        : processStatus.step3[record.status] == 'error'
                                            ? '第三步：退回待修改'
                                            : '已完成 √'
                                " :disabled="true" :status="processStatus.step3[record.status] ?? 'finish'"
                                v-if="[5, 6, 7, 8, 9, 10].includes(record.status)">
                                <template #description>
                                    <a-button type="primary" :loading="record.chaloading" class="mt-1x" size="small"
                                        v-if="[5, 6, 7].includes(record.status)"
                                        @click="handleCheckStatus(record)">查询结果</a-button>
                                </template>
                            </a-step>
                        </a-steps>
                        <a-steps direction="vertical" size="small" v-if="record.main_type != 2" :percent="60">
                            <a-step :disabled="true"
                                :title="'第一步 ' + (processStatus.ngt_step1[record.status] ? '进行中......' : '已完成 √')"
                                :status="processStatus.ngt_step1[record.status] ?? 'finish'">
                                <template #description>
                                    <a-image v-for="(item, idx) in record.business_license_and_copy" :key="idx"
                                        :width="20" :src="$store.state.user.image_domain + item" class="giveborder" />
                                    <a-image :width="20" v-if="record.push_proof"
                                        :src="$store.state.user.image_domain + record.push_proof" class="giveborder" />
                                    <span v-if="record.publicity_time_end">,公式日期：{{ record.publicity_time }}~{{
                                        record.publicity_time_end }}</span>
                                    <a-button type="primary" class="mt-1x" :loading="record.zfgsloading" size="small"
                                        v-if="[1].includes(record.status)"
                                        @click="uploadLetter(record)">上传全体投资人承诺书</a-button>
                                    <a-button type="primary" class="ml-1x mt-1x" :loading="record.zfgsloading"
                                        size="small" v-if="[2, 13].includes(record.status)"
                                        @click="handleZFGS(record)">操作第一步</a-button>
                                </template>
                            </a-step>
                            <a-step :disabled="true"
                                :title="'第二步 ' + (processStatus.ngt_step2[record.status] ? '' : '已完成 √')"
                                :status="processStatus.ngt_step2[record.status] ?? 'finish'"
                                v-if="![1, 2, 3, 13].includes(record.status)">
                                <template #description>
                                    <a-image :width="20" v-if="record.cancel_proof"
                                        :src="$store.state.user.image_domain + record.cancel_proof"
                                        class="giveborder" />
                                    <a-button type="primary" :loading="record.zxloading" @click="zhuxiao(record)"
                                        class="ml-1x mt-1x" size="small"
                                        v-if="record.status == 4 || record.status == 15">操作第二步</a-button>
                                </template>
                            </a-step>
                            <a-step :disabled="true" :title="processStatus.step3[record.status] == 'process'
                                    ? '等待审核结果'
                                    : processStatus.step3[record.status] == 'wait'
                                        ? '第三步 进行中......'
                                        : processStatus.step3[record.status] == 'error'
                                            ? '第三步：退回待修改'
                                            : '已完成 √'
                                " :status="processStatus.step3[record.status] ?? 'finish'"
                                v-if="[5, 6, 7, 8, 9, 10].includes(record.status)">
                                <template #description>
                                    <a-button type="primary" :loading="record.chaloading" size="small"
                                        v-if="[5, 6, 7].includes(record.status)"
                                        @click="handleCheckStatus(record)">查询结果</a-button>
                                </template>
                            </a-step>
                        </a-steps>
                    </div>
                </template>
                <template v-else-if="column.dataIndex === 'sellerid'">
                    <p class="mb-x">代理商：{{ record.sellerName ? record.sellerName : '-' }}</p>
                    <p class="mb-x" @click="handleCopyClick(record.lianxi_mobile)">
                        单来源：<a-avatar :size="18" :src="record.headimgurl" v-if="record.membernickname">
                            <template #icon>
                                <UserOutlined />
                            </template> </a-avatar>{{ record.membernickname }}

                        <span v-if="!record.membernickname"><a-avatar :size="18">
                                <template #icon>
                                    <UserOutlined />
                                </template> </a-avatar>未关注公众号<a-image :width="18"
                                src="https://hncs.cskaiyela.com/wxewm.jpg" /></span>
                    </p>
                    <span>{{ record.created_at }}<a @click="handleCopyClick(record.lianxi_mobile)" class="ml-1x">
                            <CopyOutlined />
                        </a></span>
                </template>
                <template v-else-if="column.dataIndex === 'action'">
                    <div class="mb-x">
                        <p>
                            <a @click="handleEdit(record)">编辑 </a>
                            <a-divider type="vertical" v-if="record.main_type != 2" />
                            <a-popover trigger="click" overlayClassName="customer-options-popover"
                                v-if="record.main_type != 2">
                                <template #content>
                                    <div v-for="(item, index) in record.DownType" :key="index" @click="downLease(item)">
                                        <p>{{ item.name }}</p>
                                    </div>
                                </template>
                                <a>下载</a>
                            </a-popover>
                            <a-divider type="vertical" />
                            <a-popconfirm title="确定删除此注销单?" @confirm="handleDelete(record)"
                                v-if="record.status == 1 || record.status == 2">
                                <a style="color: red">删除</a>
                            </a-popconfirm>
                            <a-popconfirm title="确定设为注销失败?" @confirm="handleDelete(record)"
                                v-else-if="record.status != 9 && record.status != 10">
                                <a style="color: red">设为失败</a>
                            </a-popconfirm>
                        </p>
                    </div>
                </template>
            </template>
        </a-table>
        <!-- 查看日志 -->
        <view-log :logTabsKey="data.logTabsKey" v-if="data.visibleLog" :tableColumnsData="data.tableColumnsData"
            @cancel="viewLogCancel"></view-log>
        <!-- 登录授权：公示 -->
        <login-authorisation :tableColumnsData="data.tableColumnsData" v-if="data.authorisationVisible"
            @cancel="handleCancel" @ok="handleAuthorisationOk"></login-authorisation>
        <!-- 登录授权:登记 -->
        <login-verification :tableColumnsData="data.tableColumnsData" v-if="data.verificationVisible"
            @cancel="handleCancel" @ok="handleVerificationOk"></login-verification>
        <!-- 查看签名状态 -->
        <SignatureStatus :tableColumnsData="data.tableColumnsData" v-if="data.signatureStatusVisible" @cancel="
            () => {
                data.signatureStatusVisible = false
            }
        "></SignatureStatus>
        <!-- 新增客户 -->
        <create-form ref="createForm" v-if="data.visible" :key="data.createKey" :open="data.visible"
            @cancel="handleCancel" @ok="handleOk" />
        <edit-form v-if="data.editVisible" :open="true" :tableColumnsData="data.tableColumnsData" @cancel="handleCancel"
            @ok="handleOk" />
        <!-- 付款弹窗 -->
        <PayCancelCenter v-if="data.payVisible" :tableColumnsData="data.tableColumnsData" @cancel="handleCancel"
            @ok="handleOk">
        </PayCancelCenter>
        <!-- 上传全体投资人承诺书 -->
        <UploadLetter v-if="data.letterVisible" :tableColumnsData="data.tableColumnsData" @cancel="handleCancel"
            @ok="handleOk">
        </UploadLetter>
    </a-card>
</template>

<script lang="ts" setup name="CustomerList">
import { PlusOutlined, DownOutlined, UpOutlined, CopyOutlined, CloseCircleOutlined, CheckCircleOutlined, ConsoleSqlOutlined, UserOutlined } from '@ant-design/icons-vue'
import type { PaginationProps } from 'ant-design-vue'
import CreateForm from './CreateForm.vue'
import EditForm from './CreateForm.vue'
import ViewLog from './components/ViewLog.vue'
import LoginAuthorisation from './components/LoginAuthorisation.vue'
import LoginVerification from './components/LoginVerification.vue'
import SignatureStatus from './components/SignatureStatus.vue'
import PayCancelCenter from './components/PayCancelCenter.vue'
import UploadLetter from './components/UploadLetter.vue'
import { useRouter } from 'vue-router'
import { message, Modal, Table } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import baseServicePlus from '@/utils/http/axiosPlus'
import { unref, ref, reactive, h, onMounted, computed, onActivated, customRef, onUnmounted } from 'vue'
import dayjs from 'dayjs'
import ls from '@/utils/Storage'
import { costByPoints } from '@logicflow/core/types/util'
import { useStore } from 'vuex'
import { state } from '@antv/g2plot/lib/adaptor/common'
const $store = useStore()
const arrayMonent = [dayjs('00:00:00', 'HH:mm:ss'), dayjs('23:59:59', 'HH:mm:ss')]
const token = ls.get('ACCESS_TOKEN').replace('Bearer ', '')
const user = ls.get('USER_INFO')
const router = useRouter()
const format = 'YYYY-MM-DD HH:mm:ss'

interface intervalList {
    timer: any
    time: number
}
interface data {
    tabsKey: number
    directPaymentVisible: boolean
    pushPaymentVisible: boolean
    visibleLog: boolean //log弹窗的显示
    tableColumnsData: Object //传数据的
    logTabsKey: number //log选项卡的序号
    optionsVisible: boolean
    visible: boolean
    advanced: boolean
    loading: boolean //表格的加载中
    editVisible: boolean //编辑弹窗
    authorisationVisible: boolean //登录授权
    verificationVisible: boolean
    signatureStatusVisible: boolean
    refundVisible: boolean
    exportLoading: boolean
    createKey: number //添加的key
    downList: any
    intervalList: intervalList[]
    payVisible: boolean
    letterVisible: boolean
    queryParamstatus: boolean
    navig: any
}
const data = reactive<data>({
    tabsKey: 0,
    exportLoading: false,
    // 付款弹窗
    directPaymentVisible: false,
    // 推送付款
    pushPaymentVisible: false,
    visibleLog: false,
    // 操作弹窗
    optionsVisible: false,
    // create model
    visible: false,
    // 高级搜索 展开/关闭
    advanced: false,
    tableColumnsData: {},
    loading: false,
    // 编辑
    editVisible: false,
    //登录授权
    authorisationVisible: false,
    verificationVisible: false,
    // 查看签名状态
    signatureStatusVisible: false,
    refundVisible: false,
    // 进入日志 还是进入状态
    logTabsKey: 1,
    createKey: 1,
    /* 下载列表 */
    downList: {},
    intervalList: [],
    payVisible: false,
    letterVisible: false,
    queryParamstatus: false,
    navig: {}
})
const filteredInfo = ref()
const createForm = ref()

const columns = computed(() => {
    const filtered = filteredInfo.value || []
    return [
        {
            title: '公司名称',
            dataIndex: 'full_name',
            width: 350
        },
        {
            title: '当前状态',
            dataIndex: 'status',
            width: 350
        },

        {
            title: '注销控制台',
            dataIndex: 'appFlog_sumType',
            width: 480
        },

        {
            title: '其他信息',
            dataIndex: 'sellerid',
            width: 240
        },
        {
            title: '操作',
            dataIndex: 'action',
            width: 240
        }
    ]
})
const formLayout = {
    labelCol: {
        xs: { span: 4 },
        sm: { span: 4 }
    },
    wrapperCol: {
        xs: { span: 16 },
        sm: { span: 16 }
    }
}
let queryParam = reactive<any>({
    status: []
})
let dataSource = ref([])
const pagination = reactive<PaginationProps>({
    pageSize: 10,
    pageSizeOptions: ['10', '20', '40', '50', '60', '200'],
    current: 1,
    total: undefined,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total) => `总数：${total}`
})
onMounted(() => {
    loadData()
    cancelNavig()
})
onUnmounted(() => {
    data.intervalList.forEach((item) => {
        clearInterval(item.timer)
    })
})
onActivated(() => {
    queryParam.nameOrCode = router.currentRoute.value.query.customer_name
    if (router.currentRoute?.value?.query?.customer_name) {
        loadData()
    }
})

const handleDelete = (record) => {
    let requestParam = {
        url: '/admin/v1/simpleLogout/' + record.id,
        method: 'delete'
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg)
            loadData()
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败')
            }
        })
}

// 时间选择
const rangTime = computed(() => {
    let array: any = []
    if (queryParam.between_time) {
        array = queryParam.between_time.split(',').map((item) => dayjs(item ? item : null, format))
    } else {
        array = []
    }
    return array
})
// 时间选择
const rangTimeChange = (val, str) => {
    if (val) {
        queryParam.between_time = str.join(',')
    } else {
        queryParam.between_time = null
    }
}
// 时间选择
const checkTime = computed(() => {
    let array: any = []
    if (queryParam.check_time) {
        array = queryParam.check_time.split(',').map((item) => dayjs(item ? item : null, format))
    } else {
        array = []
    }
    return array
})
// 时间选择
const checkTimeChange = (val, str) => {
    if (val) {
        queryParam.check_time = str.join(',')
    } else {
        queryParam.check_time = null
    }
}
// 复制名称
const handleNameClick = (e, name) => {
    if (e.detail == 1) {
        var input = document.createElement('input')
        //将input的值设置为需要复制的内容
        input.value = name
        //添加input标签
        document.body.appendChild(input)
        //选中input标签
        input.select()
        //执行复制
        document.execCommand('copy')
        //成功提示信息
        message.success('复制成功，尝试双击有惊喜！')
        //移除input标签
        document.body.removeChild(input)
    }
}

// 列表数据
const loadData = () => {
    if (data.loading) {
        return
    }
    data.loading = true
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/simpleLogoutList',
        method: 'post',
        data: Object.assign({ page: pagination.current, limit: pagination.pageSize }, queryParam)
    }
    baseService(requestParam)
        .then((res) => {
            data.loading = false
            pagination.total = res.data.total_records
            dataSource.value = res.data.list.map((item) => {
                if (queryParam.nameOrCode) {
                    item.fullName = item.full_name.replace(queryParam.nameOrCode, `<span style="color: red">${queryParam.nameOrCode}</span>`)
                } else {
                    item.fullName = item.full_name
                }
                return { ...item, isShowOptions: false, isShowCompany: false, desc: null, deleteType: null, customer_id: item.id }
            })
            let downList: any = []
            for (const key in res.data.down_type) {
                downList.push({ type: key, name: res.data.down_type[key] })
            }
            data.downList = downList
        })
        .catch((res) => {
            data.loading = false
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('客户列表查询失败,请联系管理员')
            }
        })
}

// 表格分页查询
const onChange = (val, filters) => {
    pagination.pageSize = val.pageSize
    pagination.current = val.current
    loadData()
}

//右上角的查询客户签字状态
const onActionClick = (record, type) => {
    record.isShowOptions = false
    data.tableColumnsData = { ...record }
    switch (type) {
        case 'SignatureStatus':
            data.signatureStatusVisible = true
            break
        case 'Refund':
            data.refundVisible = true
            break
    }
}

//右上角的添加和编辑
const handleAdd = () => {
    data.tableColumnsData = {}
    data.visible = true
}

const handleEdit = (record) => {
    data.editVisible = true
    data.tableColumnsData = { ...record }
}

const handleAuthorisationOk = (...record) => {
    data.authorisationVisible = false
    //操作具体内容
    let line = dataSource.value.find((item: any) => item.id == record[0])
    ZFGSOneItem(line)
}

const handleVerificationOk = (...record) => {
    data.visible = false
    data.refundVisible = false
    data.editVisible = false
    data.authorisationVisible = false
    data.verificationVisible = false
    data.directPaymentVisible = false
    //操作具体内容
    if (record[1] == 1) {
        //注销登记的验证码回来
        dataSource.value.forEach((item: any) => {
            if (item.id == record[0]) {
                zhuxiaoOneItem(item)
            }
        })
    } else if (record[1] == 2) {
        // 注销查询
        let item = dataSource.value.find((item: any) => item.id == record[0])
        zhuxiaoCheckItem(item)
    }
}
//作废/公示
const ZFGSOneItem = (record) => {
    let intervalObj = <intervalList>{
        timer: null,
        time: 5000
    }
    data.intervalList.push(intervalObj)
    record.zfgsloading = true
    const hide = message.loading({
        content: '操作中,请稍等',
        duration: 0,
        class: 'loading-message'
    })
    let requestParam = {
        url: `/admin/v1/cancellationZFGS`,
        method: 'post',
        data: { id: record.id }
    }
    baseServicePlus(requestParam, intervalObj)
        .then((res: any) => {
            message.success(res.msg)
            record.status = res.data.status
            record.order_status = res.data.order_status
            record.business_license_and_copy = [...res.data.business_license_and_copy]
            record.push_proof = res.data.push_proof
        })
        .catch((res) => {
            message.error(res.msg)
        })
        .finally(() => {
            record.zfgsloading = false
            setTimeout(hide, 0)
        })
}
//注销登记
const zhuxiaoOneItem = (record: any) => {
    // 操作转圈
    record.zxloading = true
    let interval //定时器
    const hide = message.loading({
        content: '操作中,请稍等',
        key: 'zhuxiaoKey',
        class: 'loading-message'
    })
    //发请求去后端    console.log(record)
    let requestParam = {
        url: '/admin/v1/cancellationZhuxiao?id=' + record.id,
        method: 'POST'
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success({ content: '注销执行中,请稍后', key: 'zhuxiaoKey', duration: 2 })
        })
        .catch((res) => {
            record.zxloading = false
            clearInterval(interval)
            message.error({ content: res.msg ? res.msg : '注销执行失败', key: 'zhuxiaoKey', duration: 2 })
        })
    //监听python是否作废完成（作废的图片存到了数据库）
    interval = setInterval(() => {
        let requestParam = {
            url: `/admin/v1/cancellationZhuxiaoCheck?id=` + record.id,
            method: 'get'
        }
        baseService(requestParam)
            .then((res: any) => {
                if (res.msg == 'ok') {
                    record.zxloading = false
                    record.status = res.data.status
                    record.order_status = res.data.order_status
                    record.cancel_proof = res.data.cancel_proof
                    clearInterval(interval)
                }
            })
            .catch((res) => { })
    }, 5000)
}
//注销状态查询
const zhuxiaoCheckItem = (record: any) => {
    let intervalObj = <intervalList>{
        timer: null,
        time: 5000
    }
    data.intervalList.push(intervalObj)
    record.chaloading = true
    const hide = message.loading({
        content: '操作中,请稍等',
        duration: 0,
        class: 'loading-message'
    })
    let requestParam = {
        url: `/admin/v1/cancellationZXCheck`,
        method: 'post',
        data: { id: record.id }
    }
    baseServicePlus(requestParam, intervalObj)
        .then((res: any) => {
            message.success(res.msg)
            record.status = res.data.status
            record.order_status = res.data.order_status
        })
        .catch((res) => {
            message.error(res.msg)
        })
        .finally(() => {
            record.chaloading = false
            setTimeout(hide, 0)
        })
}
const handleOk = (type = '', id = '') => {
    if (type == 'add') {
        //检查是否需要付款
        checkPayStatus(id)
    }
    data.createKey++
    data.visible = false
    data.refundVisible = false
    data.editVisible = false
    data.authorisationVisible = false
    data.verificationVisible = false
    data.directPaymentVisible = false
    data.payVisible = false
    data.letterVisible = false
    loadData()
}
const handleCancel = () => {
    data.visible = false
    data.editVisible = false
    data.authorisationVisible = false
    data.verificationVisible = false
    data.refundVisible = false
    data.directPaymentVisible = false
    data.payVisible = false
    data.letterVisible = false
}

// 查询日志
const onViewLogClick = (record, val) => {
    data.visibleLog = true
    data.tableColumnsData = { ...record }
    data.logTabsKey = val
}
const viewLogCancel = (isRefresh) => {
    if (isRefresh) {
        loadData()
    }
    data.visibleLog = false
}

//营业执照作废和公示
const handleZFGS = async (record) => {
    let pay_status = await checkPayStatus(record.id)
    if (pay_status == 1 || user.id == 1) {
        //检查是否还在有效期内
        let param = {
            url: '/admin/v1/cancellationSMSOrQrocde1?id=' + record.id,
            method: 'get'
        }
        baseService(param).then((res: any) => {
            if (res.msg == 'youxiao') {
                handleAuthorisationOk(record.id)
            } else {
                // 弹出填验证码的框
                data.tableColumnsData = { ...record }
                data.authorisationVisible = true
            }
        })
    } else {
        message.error('请先付款')
    }
}
//注销登记
const zhuxiao = (record) => {
    //检查是否还在有效期内
    let param = {
        url: '/admin/v1/cancellationSMSOrQrocde2?id=' + record.id,
        method: 'get'
    }
    baseService(param).then((res: any) => {
        if (res.msg == 'youxiao') {
            handleVerificationOk(record.id, 1)
        } else {
            data.tableColumnsData = { ...record }
            data.tableColumnsData['steptype'] = 1 //标记是登记
            data.verificationVisible = true
        }
    })
}
//查询注销状态
const handleCheckStatus = (record) => {
    let param = {
        url: '/admin/v1/cancellationSMSOrQrocde2?id=' + record.id,
        method: 'get'
    }
    baseService(param).then((res: any) => {
        if (res.msg == 'youxiao') {
            handleVerificationOk(record.id, 2)
        } else {
            data.tableColumnsData = { ...record }
            data.tableColumnsData['steptype'] = 2 //标记是查询
            data.verificationVisible = true
        }
    })
}
// 跳转天眼查
const handleDoubleNameClick = (name, type) => {
    if (type == 1) {
        window.open('https://www.tianyancha.com/nsearch?key=' + name)
    } else if (type == 2) {
        window.open('https://www.qcc.com/web/search?key=' + name)
    }
}
// 跳转到税务局
const onTaxInquiryClick = (record, type) => {
    let param = `?${record.social_credit_code ? 'data-creditcode=' + record.social_credit_code + '&' : ''}data-companyname=${record.full_name}&type=1`
    if (type == 1) {
        window.open('http://hunan.chinatax.gov.cn/taxpayerstatesearch/20190413003982' + param)
    } else if (type == 2) {
        window.open('http://hunan.chinatax.gov.cn/taxpayersearch/20190413003981' + param)
    } else if (type == 3) {
        window.open('http://hunan.chinatax.gov.cn/taxreginfosearch/20190413003984' + param)
    }
}
//公司下载全体投资人承诺书
const downLease = (downItem) => {
    if (downItem?.children?.length > 0) {
        return
    }
    let url = downItem.url.replace('https://console.cskaiyela.com/hncskaiyela', '')
    const hide = message.loading({
        content: '等待下载中,请稍等',
        duration: 0,
        class: 'loading-message'
    })
    let requestParam = {
        url: url,
        method: 'get'
    }
    baseService(requestParam)
        .then((res) => {
            let a = document.createElement('a')
            let event = new MouseEvent('click')
            a.download = ''
            a.href = downItem.url + `&token=${token}&down=1`
            a.dispatchEvent(event)
            setTimeout(hide, 2000)
        })
        .catch((res) => {
            setTimeout(hide, 500)
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
}
//推送为已办结
const handleTuiSYBJ = (record) => {
    const hide = message.loading({
        content: '推送中,请稍等',
        duration: 0,
        class: 'loading-message'
    })
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/calcelLog/finish',
        method: 'post',
        data: {
            id: record.id
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            setTimeout(hide, 500)
            loadData()
            message.success(res.msg ? res.msg : '推送成功')
        })
        .catch((res) => {
            setTimeout(hide, 500)
            message.error(res.msg ? res.msg : '推送失败')
        })
}
// 进度状态选择
const tabsChange = (val) => {
    data.tabsKey = val
    if (val == 56) {
        queryParam.status = [5, 6]
        let startOfToday = dayjs().subtract(1, 'year').format('YYYY-MM-DD HH:mm:ss')
        let endOfToday = dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss')
        queryParam.check_time = startOfToday + ',' + endOfToday
    } else if (val == 'db') {
        //所有代办
        queryParam.status = [1, 2, 4, 5, 6, 7, 13, 15]
        queryParam.check_time = null
    } else {
        queryParam.status = [val]
        queryParam.check_time = null
    }
    loadData()
}
// 直接付款
const onDirectPaymentClick = (record) => {
    data.payVisible = true
    data.tableColumnsData = { ...record }
}
// 进度显示的状态
const processStatus = reactive({
    gt_step1: {
        1: 'wait',
        2: 'process',
        13: 'error'
    },
    ngt_step1: {
        1: 'wait',
        2: 'process',
        3: 'wait',
        13: 'error'
    },
    gt_step2: {
        3: 'process',
        15: 'error'
    },
    ngt_step2: {
        4: 'process',
        15: 'error'
    },
    step3: {
        5: 'wait',
        6: 'process',
        7: 'error'
    }
})
// 复制
const handleCopyClick = (val) => {
    var input = document.createElement('input')
    //将input的值设置为需要复制的内容
    input.value = val
    //添加input标签
    document.body.appendChild(input)
    //选中input标签
    input.select()
    //执行复制
    document.execCommand('copy')
    //成功提示信息
    message.success('复制成功!')
    //移除input标签
    document.body.removeChild(input)
}
//上传全体投资人承诺书
const uploadLetter = (record) => {
    data.letterVisible = true
    data.tableColumnsData = { ...record }
}
const changestatus = () => {
    if (queryParam.status.length == 1) {
        if ([1, 3, 4, 5, 6, 7].includes(queryParam.status[0])) {
            data.tabsKey = queryParam.status[0]
        } else {
            data.tabsKey = 0
        }
    } else {
        data.tabsKey = 0
    }
}
var datakeytmp = 0
var querystatus = []
const recycleChange = () => {
    if (queryParam.recycle == 1) {
        datakeytmp = data.tabsKey
        data.tabsKey = 0
        querystatus = queryParam.status
        queryParam.status = []
        data.queryParamstatus = true
    } else {
        data.tabsKey = datakeytmp
        queryParam.status = querystatus
        data.queryParamstatus = false
    }
}
//检查付款状态
const checkPayStatus = async (recordId) => {
    let requestParam = {
        url: `/admin/v1/simpleLogout/${recordId}/edit`,
        method: 'get'
    }
    let res: any = await baseService(requestParam)
    let record: any = res.data
    if (record.pay_status == 2 && user.id != 1) {
        //未付款就弹出框
        onDirectPaymentClick(record)
    }
    return record.pay_status
}
// 获取头部气泡数据
const cancelNavig = () => {
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/calcel/navig',
        method: 'get'
    }
    baseService(requestParam)
        .then((res) => {
            Object.assign(data.navig, res.data)
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('获取统计失败')
            }
        })
}
</script>
<style lang="less" scoped>
.navlist {
    button {
        margin-right: 10px;
    }
}

.tabs {
    position: relative;

    .tabs-right {
        position: absolute;
        right: 0;
        top: 0;
        padding: 12px 0;
        display: flex;
        gap: 32px;
        align-items: center;
    }
}

:deep(.tableRowClass) {
    .ant-table-cell:first-child {
        padding: 0 !important;
    }
}

.table-operator {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 35px !important;
}

.customer-options-popover {
    p {
        padding: 0 16px;
        margin: 0;
        height: 35px;
        line-height: 35px;
        cursor: pointer;
        text-align: center;
        color: #000;
    }

    p:hover {
        color: var(--ant-primary-color);
        background: var(--ant-primary-color-deprecated-bg);
    }
}

.companyInformation {
    padding: 16px;

    .deng {
        display: none;
    }
}

.companyInformation:hover {
    .deng {
        display: block;
    }
}

.statusbox {
    .deng {
        display: none;
    }
}

.statusbox:hover {
    .deng {
        display: block;
    }
}

.loading-message {
    .ant-message-notice-content {
        border: 1px solid #c8d8cf;
        color: rgb(8, 153, 68);
        background: rgb(233, 252, 241);
    }
}

:deep(.giveborder) {
    border: 2px dashed #ccc;
    padding: 1px;
}

.customer-options-popover {
    p {
        padding: 0 16px;
        margin: 0;
        height: 35px;
        line-height: 35px;
        cursor: pointer;
        text-align: center;
        color: #000;
    }

    p:hover {
        color: var(--ant-primary-color);
        background: var(--ant-primary-color-deprecated-bg);
    }
}
</style>
